"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_if_1 = require("react-if");
const utils_1 = require("../../../utils");
const ReloadButton_1 = require("./buttons/ReloadButton");
const useOsmosysStickiedReload_1 = require("../hooks/useOsmosysStickiedReload");
const NewResourceButton_1 = require("./buttons/NewResourceButton");
exports.OsmosysListLayoutToolbar = ({ toolbarLeft, showReloadButton, queryResult, toolbarRight, onReload, onNewResourceButtonClick, }) => {
    const { reload, showLoadingState } = useOsmosysStickiedReload_1.useOsmosysStickiedReload({
        isLoading: queryResult.loading,
        onReload,
    });
    return (react_1.default.createElement(utils_1.OsmosysDiv, { flexRow: true },
        react_1.default.createElement(react_if_1.When, { condition: !!toolbarLeft },
            react_1.default.createElement(utils_1.OsmosysDiv, { flexColCentered: true }, toolbarLeft && toolbarLeft(queryResult))),
        react_1.default.createElement(utils_1.OsmosysDiv, { flexColCenteredFilled: true }),
        react_1.default.createElement(react_if_1.When, { condition: !!(toolbarRight || showReloadButton) },
            react_1.default.createElement(react_if_1.When, { condition: !!toolbarRight },
                react_1.default.createElement(utils_1.OsmosysDiv, { flexColCentered: true }, toolbarRight && toolbarRight(queryResult))),
            react_1.default.createElement(react_if_1.When, { condition: !!showReloadButton },
                react_1.default.createElement(utils_1.OsmosysDiv, { flexColCentered: true, marginLeft: true },
                    react_1.default.createElement(ReloadButton_1.OsmosysListLayoutReloadButton, { reload: reload, loading: showLoadingState })),
                react_1.default.createElement(react_if_1.When, { condition: !!onNewResourceButtonClick },
                    react_1.default.createElement(utils_1.OsmosysDiv, { flexColCentered: true },
                        react_1.default.createElement(NewResourceButton_1.OsmosysListLayoutNewResourceButton, { onNewResourceButtonClick: onNewResourceButtonClick })))))));
};
//# sourceMappingURL=index.js.map